import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-accessibility-header',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './accessibility-header.component.html',
  styleUrl: './accessibility-header.component.scss'
})
export class AccessibilityHeaderComponent {
    isMirrored: boolean = false;
  toggleDarkMode(): void {
    this.isMirrored = !this.isMirrored;

  }

  sendMail() {
window.location.href = "mailto:iasca.helpdesk@zohomail.in?subject=Help%20Desk%20Support&body=Hello,%0D%0A%0D%0AI am contacting the Help Desk for assistance.%0D%0A%0D%0ARegards,";
}

scrollToContent() {
  const element = document.getElementById('mainContent');
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

}
